import {useState} from 'react'
import {useNavigate} from 'react-router-dom'

import Style from './style'

import PageTitle from 'widget/PageTitle'
import DefaultButton from 'shared/ui/DefaultButton'
import AgreeModal from 'widget/AgreeModal'

import useGetTryoutExamList from 'entity/tryoutExam/useGetExamList'

import tryoutTerm from 'shared/constant/term/tryoutTerm'
import {convertProGradeAsName} from 'shared/constant/lookup/proGrade'
import timestampCalculator from 'shared/lib/timestampCalculator'

import {ReactComponent as ArrowDown} from 'page/ui/Mypage/asset/arrow_down.svg'
import {ReactComponent as ArrowUp} from 'page/ui/Mypage/asset/arrow_up.svg'

const TryoutExamList = () => {
	const navigate = useNavigate()

	const [isModalShow, setIsModalShow] = useState(false)
	const [proGradeType, setProGradeType] = useState(null)
	const [examIdx, setExamIdx] = useState(null)
	const [price, setPrice] = useState(null)
	const [branchName, setBranchName] = useState(null)
	const [expandedBranches, setExpandedBranches] = useState({})

	const [tryoutExamList] = useGetTryoutExamList()

	const tmpTerm = [
		{
			title: '트라이아웃 필기 시험 결제 및 응시 약관 (필수)',
			content: tryoutTerm,
		},
	]

	// Admin exams list
	const adminExams = tryoutExamList?.data?.admin
		? [
				tryoutExamList?.data?.admin?.rookie,
				tryoutExamList?.data?.admin?.semi,
				tryoutExamList?.data?.admin?.tour,
			]
		: []

	// Branches data
	const branches = tryoutExamList?.data?.branches || {}

	const showModalEvent = (elem, branch = null) => {
		setIsModalShow(true)
		setProGradeType(elem?.pro_grade_flag)
		setExamIdx(elem?.idx)
		setPrice(elem?.price)
		setBranchName(branch || elem?.manager_name)
	}

	const toggleBranch = (branchName) => {
		setExpandedBranches((prev) => ({
			...prev,
			[branchName]: !prev[branchName],
		}))
	}

	const renderExamItem = (exam, isChild, branch = null) => {
		if (!exam) return null
		console.log('exam: ', exam)
		return (
			<Style.ExamElement key={exam.idx}>
				<Style.ExamTitleDiv>
					<h1>
						{' '}
						{isChild
							? exam?.qualification_name
							: convertProGradeAsName[exam?.pro_grade_flag] + ' Pro'}{' '}
						필기 시험
					</h1>
					<h2>Version {exam?.version}</h2>
					<p>{timestampCalculator(exam?.created_at, 'date')}</p>
				</Style.ExamTitleDiv>
				<Style.TakingButtonDiv>
					<Style.TakingButtonDiv>
						<DefaultButton
							clickEvent={() => showModalEvent(exam, branch)}
							small
							deactive={!exam?.is_available}
						>
							Take Exam
						</DefaultButton>
					</Style.TakingButtonDiv>
				</Style.TakingButtonDiv>
			</Style.ExamElement>
		)
	}

	return (
		<>
			{isModalShow && (
				<AgreeModal
					title='약관 동의'
					closeEvent={() => setIsModalShow((state) => !state)}
					list={tmpTerm}
					buttonLabel='결제하기'
					clickEvent={() =>
						navigate(
							`/payment/exam?proGradeType=${proGradeType}&examIdx=${examIdx}&price=${price}&branchName=${branchName}`
						)
					}
				/>
			)}

			<Style.Wrapper>
				<PageTitle>Tryout Written Exam</PageTitle>

				<Style.ExamList>
					{/* Admin exams - always visible */}
					<Style.AdminExams>
						{adminExams.map((exam) => renderExamItem(exam))}
					</Style.AdminExams>

					{/* Branch exams - expandable */}
					{Object.entries(branches).map(([branchName, branchExams]) => (
						<Style.BranchSection key={branchName}>
							<Style.BranchHeader
								onClick={() => toggleBranch(branchName)}
								$isExpanded={expandedBranches[branchName]}
							>
								<Style.BranchHeaderContent
									$isExpanded={expandedBranches[branchName]}
								>
									<h1>{branchName} Tryout Written Exam</h1>
									<Style.ExpandIcon $isExpanded={expandedBranches[branchName]}>
										{expandedBranches[branchName] ? <ArrowUp /> : <ArrowDown />}
									</Style.ExpandIcon>
								</Style.BranchHeaderContent>
							</Style.BranchHeader>

							{expandedBranches[branchName] && (
								<Style.BranchContent>
									{branchExams?.rookie &&
										renderExamItem(branchExams.rookie, true, branchName)}
									{branchExams?.semi &&
										renderExamItem(branchExams.semi, true, branchName)}
									{branchExams?.tour &&
										renderExamItem(branchExams.tour, true, branchName)}
								</Style.BranchContent>
							)}
						</Style.BranchSection>
					))}
				</Style.ExamList>
			</Style.Wrapper>
		</>
	)
}

export default TryoutExamList
